import { Component, Input, ViewChild } from '@angular/core'
import { NgbNav } from '@ng-bootstrap/ng-bootstrap'
import { IDataCardSDL } from '../../../../../models/data-card.model'
import { NzModalService } from 'ng-zorro-antd/modal'
import { NotificationsModalComponent } from '../notifications-modal/notifications-modal.component'

@Component({
    selector: 'app-data-sdl',
    templateUrl: './data-sdl.component.html',
    standalone: false
})
export class DataSdlComponent {
  @ViewChild('nav') private nav: NgbNav
  @Input() data: IDataCardSDL
  @Input() hasCMMSPackage: boolean = false

  constructor(private nzModalService: NzModalService) {}

  public onOpenNotificationModal(tag: string, notifications?: number): void {
    if (!notifications) {
      return
    }
    this.nzModalService.create<NotificationsModalComponent, { mainObject: string }, any>({
      nzContent: NotificationsModalComponent,
      nzStyle: { top: '30px' },
      nzData: { mainObject: tag },
      nzNoAnimation: true,
    })
  }
}
